import { render, staticRenderFns } from "./WellnessDots.vue?vue&type=template&id=530818a6&scoped=true"
import script from "./WellnessDots.vue?vue&type=script&lang=js"
export * from "./WellnessDots.vue?vue&type=script&lang=js"
import style0 from "./WellnessDots.vue?vue&type=style&index=0&id=530818a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530818a6",
  null
  
)

export default component.exports